import React , {useState, useEffect} from 'react'
import axios from 'axios';
import book from '../../src/book.jpg'

function Form() {

    const [word,setWord] = useState("");

    const[syns, setSyns] = useState([]);


    useEffect(() => {

       const options = {
        method: 'GET',
        url: `https://rapidapi.p.rapidapi.com/words/${word}/synonyms`,
        headers: {
          'x-rapidapi-host': 'wordsapiv1.p.rapidapi.com',
          'x-rapidapi-key': '03179e6cf6mshbaa7751ed498917p173c3cjsn22daca94905b'
        }
      };
      
      axios.request(options).then(function (response) {
          console.log(response.data);
          const syns = response.data;
          setSyns(syns.synonyms);

      }).catch(function (error) {
          console.error(error);
      });      
            
      },[word])

      console.log(syns)

    return (
        <div className= "form-container">
         <div>
         <img className="image" src={book} alt="book" />
        <h3>Start Typing a Word...</h3>
        </div>
         <form>
         <input type="text" name ="word" value={word} onChange={ e => setWord(e.target.value)}></input>
         </form>

        <div className="list-container">

        {word !== '' ? syns.map(syn => <p> {syn} </p> ) : null }

        </div>
            
        </div>
    )
}

export default Form
